import script from "./CorporateNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CorporateNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./CorporateNavigation.vue?vue&type=style&index=0&id=5171f385&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5171f385"]])

export default __exports__